import React from 'react';
import Logo from '../images/Logo.png'
import * as Head from '../styles/Header.module.scss'
const Header = props => {
    return (
        <div className={Head.header}>
            <div className={Head.wrap}>
                <div className={Head.luminelogo}>
                    <img src={Logo} alt='Logo' />
                </div>

            </div>
        </div>
    )
}

export default Header